import type { FC } from "react";
import { RecentTab } from "web_myplann/NotificationCenter/Components/RecentTab";
import { UpcomingTab } from "web_myplann/NotificationCenter/Components/UpcomingTab";
import {
	NOTIFICATION_CENTER_TABS,
	type NotificationCenterTab,
} from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";

type Props = {
	activeTab: NotificationCenterTab;
};

export const NotificationCenterTabContent: FC<Props> = ({ activeTab }) => (
	<>
		{activeTab === NOTIFICATION_CENTER_TABS.Upcoming && <UpcomingTab />}
		{activeTab === NOTIFICATION_CENTER_TABS.Recent && <RecentTab />}
	</>
);
